import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import TextFormListItem from "../molecules/TextFormListItem";

interface MailSystemSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const MailSystemSettings: React.FC<MailSystemSettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [mailLogSenderError, setMailLogSenderError] = React.useState(false)
    const [mailLogSenderHelperText, setMailLogSenderHelperText] = React.useState("")

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="メール配信システム関連設定"
            />
            <List>
                <TextFormListItem
                    text="ログメール配信先"
                    initialValue={systemValue?.MAIL_LOG_SENDER ? systemValue.MAIL_LOG_SENDER : ""}
                    onValidate={value => {
                        if (!value.match(/.+@.+\..+/)) {
                            setMailLogSenderError(true)
                            setMailLogSenderHelperText("メールアドレスを入力してください")
                        } else {
                            setMailLogSenderError(false)
                            setMailLogSenderHelperText("")
                        }
                    }}
                    onSave={(value) => {
                        if (onSave) {
                            onSave("MAIL_LOG_SENDER", value)
                        }
                    }}
                    error={mailLogSenderError}
                    helperText={mailLogSenderHelperText}
                />
            </List>
        </Paper>
    );
}

export default MailSystemSettings